export default {
  modelName: 'organization',
  label: '集團管理',
  fields: {
    area: {
      type: 'belongsTo',
      label: '適用地區',
      rules: 'required',
      textKey: 'name',
      modelName: 'area',
      clearable: true,
    },
    area_section: {
      label: '適用子地區',
      type: 'belongsTo',
      textKey: 'name',
      clearable: true,
      modelName: 'area_section',
      placeholder: '選擇子地區',
      requiredField: 'area',
      conditionKeys: [
        {
          fieldName: 'area',
          conditionName: 'area',
        },
      ],
    },
    plan: {
      type: 'belongsTo',
      label: '選擇方案',
      rules: 'required',
      textKey: 'name',
      modelName: 'plan',
    },
    license_type: {
      type: 'belongsTo',
      label: '證照類型',
      rules: 'required',
      textKey: 'name',
      modelName: 'license_type',
      requiredField: 'area',
      conditionKeys: [
        {
          fieldName: 'area',
          conditionName: 'area',
        },
      ],
    },
    sequence: {
      type: 'text',
      label: '排序',
      maxlength: 10,
    },
    locales: {
      type: 'locales',
      fields: {
        name: {
          type: 'text',
          label: '集團名稱',
          autofocus: true,
          rules: 'required',
          maxlength: 200,
        },
      },
    },
    name: {
      type: 'text',
      label: '集團名稱',
    },
    remark: {
      type: 'textarea',
      label: '備註',
      maxlength: 1000,
    },
    organization: {
      type: 'belongsTo',
      label: '所屬集團',
      textKey: 'name',
      modelName: 'organization',
    },
    app: {
      type: 'belongsTo',
      label: '客戶系統管理',
      textKey: 'name',
      modelName: 'app',
      rules: 'required',
    },
    system_class: {
      type: 'belongsTo',
      label: '領域',
      textKey: 'name',
      modelName: 'system_class',
      requiredField: 'area',
      conditionKeys: [
        {
          fieldName: 'area',
          conditionName: 'area',
        },
      ],
    },
    system_subclasses: {
      conditionKeys: [
        {
          fieldName: 'system_class',
          conditionName: 'system_class',
          type: 'array',
        },
      ],
      requiredField: 'system_class',
      label: '子領域',
      type: 'hasMany',
      textKey: 'name',
      modelName: 'system_subclass',
    },
    industry_categories: {
      label: '選擇產業類別',
      type: 'hasMany',
      textKey: 'name',
      modelName: 'industry_category',
    },
    status: {
      type: 'switch',
      label: '啟用狀態',
      defaultValue: true,
      activeText: '啟用',
      inactiveText: '關閉',
    },
    update_active: {
      type: 'switch',
      label: '啟用狀態',
      defaultValue: true,
      activeText: '啟用',
      inactiveText: '關閉',
    },
    updated_at: {
      type: 'datetime',
      label: '最後更新時間',
      readonly: true,
    },
    updated_admin: {
      type: 'belongsTo',
      label: '最後更新人',
      readonly: true,
      textKey: 'name',
      modeldataName: 'admin',
    },
    created_at: {
      type: 'datetime',
      label: '建立時間',
      readonly: true,
      textKey: 'name',
    },
    created_admin: {
      type: 'belongsTo',
      label: '建立者',
      readonly: true,
      textKey: 'name',
    },
    updated_info: {
      type: 'custom',
      label: '上次修改時間',
      getValue: (item) => {
        let _value = item.updated_at;
        if (item.updated_admin) {
          _value += `  ${item.updated_admin}`;
        }
        return _value;
      },
    },
    tags: {
      label: '全域標籤設定',
      type: 'hasMany',
      inLocale: true,
      textKey: 'name',
      modelName: 'tag',
      hasCloseChips: true,
      // valueKey: "name"
    },
    administrator_name: {
      label: '系統管理員',
      type: 'text',
      placeholder: '請輸入系統管理員名稱',
      rules: 'required',
    },
    administrator_email: {
      label: '系統管理員帳號/email',
      type: 'email',
      autocomplete: 'new-password',
      rules: 'required',
      des: `
      此帳號取名需具特殊/唯一性、不必是可以收信的真實email、不可與 任何前台使用者帳號 或 其他工廠/集團系統管理員帳號 重複。
      建議可使用@esgoaladministrator.com做結尾較不容易發生重複，@前面可用客戶代號命名，例如：llgroup01@esgoaladministrator.com。
      此帳號作為工廠/集團初始登入使用並擁有最大權限，請妥善保管帳號密碼。
      `
    },
    administrator_password: {
      label: '系統管理員密碼',
      type: 'password',
      autocomplete: 'new-password',
      rules: 'required',
    },
    administrator_password_updated_at: {
      label: '系統管理員密碼更新時間',
      type: 'datetime',
      readonly: true,
    },
  },
};
